import React, {memo, useEffect, useState} from "react";
import axios from "axios";
import ScrollArea from "react-scrollbar";
import Loading from "../../components/Loading";


const About = ({id}) => {
    const [companyInfo, setCompanyInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState([]);

    useEffect(() => {
        if(id) {
            axios({url: `/api/widget/widget_provider?id=${id}`})
                .then(response => {
                    const data = response.data.result;

                    if(data) {
                        setCompanyInfo(data);
                    } else {
                        setErrors(['Что-то пошло не так...']);
                    }

                    setLoading(false);
                })
                .catch(e => {
                    if(e.isAxiosError && e.response) {
                        if(e.response.data.errors) {
                            setErrors(Object.keys(e.response.data.errors).map(key => `Ошибка ${key}: ${e.response.data.errors[key]}`));
                        } else {
                            setErrors([`Ошибка ${e.response.status}: ${e.response.statusText}`]);
                        }
                    } else {
                        setErrors(['Что-то пошло не так...']);
                    }

                    setLoading(false);
                });
        } else {
            setErrors(['Ошибка: Нет идентификатора виджета.']);
            setLoading(false);
        }
    }, [id]);

    return loading?
        <Loading/> :
        <div className="registration-for-service__about about">
            {!errors.length ?
                <ScrollArea
                    className="about__wrap-scroll"
                    contentClassName="about__scroll"
                    verticalScrollbarStyle={{borderRadius: 6, width: 6, backgroundColor: '#aaa'}}
                    verticalContainerStyle={{borderRadius: 8, width: 8}}
                    horizontal={false}
                    smoothScrolling={true}
                >
                    <h4 className="about__title">Название</h4>
                    <p className="about__info">{companyInfo.company_name}</p>
                    {companyInfo.general_information &&
                        <>
                            <h4 className="about__title">Общая информация</h4>
                            <p className="about__info">{companyInfo.general_information}</p>
                        </>
                    }
                    {companyInfo.phone &&
                        <>
                            <h4 className="about__title">Телефон</h4>
                            <p className="about__info">{companyInfo.phone}</p>
                        </>
                    }
                    {companyInfo.email &&
                        <>
                            <h4 className="about__title">E-mail</h4>
                            <p className="about__info">{companyInfo.email}</p>
                        </>
                    }
                    {companyInfo.address &&
                        <>
                            <h4 className="about__title">Город</h4>
                            <p className="about__info">{companyInfo.address}</p>
                        </>
                    }
                </ScrollArea> :
                <div className="registration-for-service__errors">
                    {errors.map((error, i) =>
                        <p key={`error-${i}`}>{error}</p>
                    )}
                </div>
            }
        </div>
};

export default memo(About);